export default __webpack_public_path__ + "static/media/3Ps Venn Diagram.13b8836b.png";